/**
 * Stale-while-revalidate cache for GET requests (10–30s TTL).
 * /api/properties excluded — always fetch fresh to avoid stale cards.
 */
const CACHE_TTL_MS = 15000; // 15s
const CACHE_PATHS = [
  "/api/balance/me",
  "/api/fast/balance",
  "/api/fast/holdings",
  "/api/holdings",
];

const cache = new Map();

function cacheKey(path, method = "GET") {
  return `${method}:${path}`;
}

export function isCacheable(path, method) {
  if (method !== "GET") return false;
  return CACHE_PATHS.some((p) => path.startsWith(p) || path === p);
}

export function getCached(path, method = "GET") {
  if (!isCacheable(path, method)) return null;
  const key = cacheKey(path, method);
  const entry = cache.get(key);
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) return null;
  return entry.data;
}

export function setCached(path, data, method = "GET", ttlMs = CACHE_TTL_MS) {
  if (!isCacheable(path, method)) return;
  const key = cacheKey(path, method);
  cache.set(key, { data, expiresAt: Date.now() + ttlMs });
}

export function invalidateCached(pathPrefix) {
  for (const key of cache.keys()) {
    if (key.endsWith(pathPrefix) || key.includes(pathPrefix)) cache.delete(key);
  }
}

export function invalidateBalanceAndHoldings() {
  invalidateCached("/api/balance");
  invalidateCached("/api/fast/balance");
  invalidateCached("/api/holdings");
  invalidateCached("/api/fast/holdings");
}

export { CACHE_TTL_MS };
